import React, { useState, useEffect } from "react";
import { useMemberstack } from "../context/MemberstackContext";
import { useNotaire } from "../context/NotaireContext";
//firebase
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { storage, auth } from "../services/firebase"; // ✅ instance centralisée
import { signInAnonymously } from "firebase/auth";
import { toast } from "react-toastify";
import {  PlusIcon, XMarkIcon, ChevronDownIcon, CheckCircleIcon } from '@heroicons/react/20/solid';
import { Dialog, DialogPanel, DialogBackdrop, DialogTitle } from '@headlessui/react';
import { Field } from '../components/catalyst/fieldset';
import { Textarea } from '../components/catalyst/textarea';
import HonoraireList from "../components/HonoraireList"; // ou le chemin correct



function Loader() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-6 animate-spin">
            <path strokeLinecap="round" strokeLinejoin="round" d="M16.023 9.348h4.992M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182M22.015 4.874v4.99" />
        </svg>
    );
}


const Honoraires = ({ user, affaire, type }) => {
    const { member } = useMemberstack();
    const notaireCtx = useNotaire();
    const [honoraire, setHonoraire] = useState([]);
    const [isOpenUpload, setIsOpenUpload] = useState(false);
    const [file, setFile] = useState(null);
    const [montant, setMontant] = useState(null);
    const [loader, setLoader] = useState(false);
    const [urlFirebase, setUrlFirebase] = useState(null);
    const [message, setMessage] = useState(false);
    const [honoraireDemande, setHonoraireDemande] = useState("");

    //firebase init
    useEffect(() => {
        const initFirebase = async () => {
            try {
                await signInAnonymously(auth);
                //console.log("User signed in anonymously");
            } catch (error) {
                console.error("Auth error:", error);
            }
        };

        initFirebase();
    }, []);


    const closeDialogUpload = () => {
        setIsOpenUpload(false);
        setUrlFirebase(null);
        setFile(null);
        setLoader(false);
    };

    const openDialogAjoutHonoraire = () => {
        setIsOpenUpload(true);
    };

    const onChangeHonoraireDemande = (event) => {
        setHonoraireDemande(event.target.value);
    };

    const onUploadFactureHonoraire = (event) => {
        //controle 
        const fileSize = event.target.files[0].size;
        const fileType = event.target.files[0].type;
        const MAX_SIZE_BYTES = 536870912; // 512 Mo
        if (fileSize >= MAX_SIZE_BYTES) {
            alert('Votre fichier est trop volumineux. Taille maximale 5MB.');
            event.target.value = ''; // clear the file input
        }
        else if (fileType !== "application/pdf") {
            alert('Le fichier doit être au format PDF.');
            event.target.value = ''; // clear the file input
        } else {
            const handleUpload = async () => {
                setLoader(true);
                try {
                    // Upload du fichier sur firestore le temps de l'upload
                    const storageRef = ref(storage, event.target.files[0].name);

                    uploadBytes(storageRef, event.target.files[0])
                        .then((snapshot) => {
                            getDownloadURL(snapshot.ref)
                                .then((url) => {
                                    //console.log("firebase url", url);
                                    setUrlFirebase(url);
                                    setFile(event.target.files[0]);
                                    //console.log("file", event.target.files);
                                    if (urlFirebase !== null) { setLoader(false); }
                                })
                                .catch((error) => {
                                    //console.log("erreur url", error);
                                });
                        })
                        .catch((error) => {
                            //console.log("erreur firebase", error);
                        });

                }
                catch (e) {
                    //console.log("Erreur lors de l'upload de votre document.",e)
                }
            }
            handleUpload();
        }
    }


    const sendDemandeHonoraire = async (event) => {
        event.preventDefault();
        setLoader(true);
        const URL = `https://api.airtable.com/v0/appD48APNaGA4GN0B/honoraires`;

        //on ajoute la facture directement dans airtable puis on appel zapier pour mettre à jour les actions et envoyer les mails
        // Mappe le type d’affaire → le champ Airtable correspondant
        const idFieldByType = {
            mariage: "id_mariage",
            pacs: "id_pacs",
            pma: "id_pma",
            immo: "id_transaction",
            certification: "id_certification",
            bail: "id_bail",
            donation: "id_donation",
            divorce: "id_divorce",
        };

        async function postHonoraire(type, affaire, member, honoraireDemande, montant, message, urlFirebase) {
            const idField = idFieldByType[type];
            if (!idField) throw new Error(`Type inconnu: ${type}`);

            const body = {
                fields: {
                    type,
                    email_notaire: notaireCtx?.notaireEmail || member.auth.email,
                    type_honoraire: honoraireDemande,
                    [idField]: [affaire.id], // champ dynamique
                    statut: "en attente",
                    montant,
                    ...(message && { message }),
                    facture: [{ url: urlFirebase }],
                },
            };

            try {
                const res = await fetch(URL, {
                    method: "POST",
                    headers: {
                        Authorization: "Bearer patfRIUbOM9xqwLV2.dfbc9a305f2124aff75634c819a8335ecd984b1d19e98f67f14013378ed6bb02",
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(body),
                });

                if (res.ok) {
                    const airtableRecordHonoraire = await res.json(); // récupère id et fields
                    await getHonoraireAffaire();
                    closeDialogUpload();
                    toast.success("Votre demande d'honoraire a bien été ajoutée.");

                    // 2) Zapier webhook
                    await fetch("https://hooks.zapier.com/hooks/catch/7206204/2pkxrc7/", {
                        method: "POST",
                        body: JSON.stringify({ member, type, affaire, urlFirebase, montant, message, honoraireDemande,airtableRecordHonoraire }),
                    });
                    

                } else {
                    toast.error("Une erreur s'est produite, veuillez recommencer.");
                }
            } catch (err) {
                console.error("❌ Erreur Airtable add :", err);
                toast.error("Une erreur réseau est survenue.");
            }
        }

        await postHonoraire(
            type,
            affaire,
            member,
            honoraireDemande,
            montant,
            message,
            urlFirebase
        );

    };

    const getHonoraireAffaire = async () => {
        if (!affaire) return;

        const fieldTypeMap = {
            pma: 'id_pma',
            immo: 'id_transaction',
            mariage: 'id_mariage',
            pacs: 'id_pacs',
            certification: 'id_certification',
            bail: "id_bail",
            donation: "id_donation",
            divorce: "id_divorce"

        };
        const field = fieldTypeMap[type] || 'id_from_pma';
        const url = `https://api.airtable.com/v0/appD48APNaGA4GN0B/honoraires?filterByFormula=({${field}} = '${affaire.id}')`;

        try {
            const res = await fetch(url, {
                headers: {
                    Authorization: "Bearer patfRIUbOM9xqwLV2.dfbc9a305f2124aff75634c819a8335ecd984b1d19e98f67f14013378ed6bb02",
                    'content-type': 'application/x-www-form-urlencoded'
                }
            });
            const data = await res.json();
            setHonoraire(data.records);
        } catch (error) {
            console.error(error);
        }
    };
    useEffect(() => {
        getHonoraireAffaire();
    }, [affaire]);




    //console.log("member", member.auth.email)
    //console.log("honoraireDemande", honoraireDemande);
    //console.log("url file", urlFirebase);
    //console.log("liste des honoraires", affaire)
    //console.log("type honoraire", type)
    return (
        <div className="flex flex-col justify-content-end align-item-center container">

            {/**

            <h5 className="flex-auto truncate text-sm font-semibold leading-6 text-gray-700">Cette démarche est facturée à l'utilisateur</h5>
            <p className="text-sm">Clotere facture des frais de dossier à l'utilisateur final, pour l'utilisation de la plateforme.</p>
            <ul className="mt-2 divide-y divide-gray-100 overflow-hidden bg-white shadow-xs ring-1 ring-gray-900/5 sm:rounded-xl">
                <li className="relative flex justify-between gap-x-6 p-4 hover:bg-gray-50  items-center">
                    <div className="flex min-w-0 gap-x-4 items-center">
                        <BookmarkIcon className="text-indigo-600 size-12" />
                        <div className="min-w-0 flex-auto">
                            <p className="text-sm/6 font-semibold text-gray-900 mb-0">
                                <span className="absolute inset-x-0 -top-px bottom-0" />
                                Frais de dossier
                            </p>
                            <span className="inline-flex items-center rounded-md bg-indigo-50 px-2 py-1 text-xs font-medium text-indigo-600 ring-1 ring-indigo-500/10 ring-inset">
                                Montant : 30€
                            </span>
                        </div>
                    </div>
                    <div className="flex shrink-0 items-center gap-x-4">

                        {affaire.statut_paiement === "non" ? (
                            <span className="inline-flex items-center rounded-md bg-red-50 px-2 py-1 text-xs font-medium text-red-600 ring-1 ring-red-500/10 ring-inset">
                                Non payé
                            </span>
                        ) : (
                            <span className="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-600 ring-1 ring-green-500/10 ring-inset">
                                Payé
                            </span>
                        )}
                    </div>
                </li>
            </ul> */}

            {/** OLD AFFICHAGE DES FACTURE CLOTERE AVEC DES PRIX DIFFÉRENTS - A GARDER POUR L'INSTANT 
                {type === "immo" && <>
                    <h5 className="flex-auto truncate text-sm font-semibold leading-6 text-gray-700">Aucun frais supplémentaire demandé hors frais de notaire</h5>
                    <ul className="mt-2 divide-y divide-gray-100 overflow-hidden bg-white shadow-xs ring-1 ring-gray-900/5 sm:rounded-xl">
                        <li className="relative flex justify-between gap-x-6 p-4 hover:bg-gray-50  items-center">
                            <div className="flex min-w-0 gap-x-4 items-center">
                                <HomeIcon className="text-indigo-600 size-12" />
                                <div className="min-w-0 flex-auto">
                                    <p className="text-sm/6 font-semibold text-gray-900 mb-0">
                                        <span className="absolute inset-x-0 -top-px bottom-0" />
                                        Dossier Immobilier
                                    </p>
                                </div>
                            </div>
                            <div className="flex shrink-0 items-center gap-x-4">
                                <span className="inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-gray-500/10 ring-inset">
                                    Gratuit pour l'utilisateur
                                </span>
                            </div>
                        </li>
                    </ul>
                </>}
                {type === "mariage" && <>
                    <h5 className="flex-auto truncate text-sm font-semibold leading-6 text-gray-700">Cette démarche est facturée à l'utilisateur</h5>
                    <p className="text-sm">Clotere vous reverse l'argent dès que le paiement a été fait.</p>
                    <ul className="mt-2 divide-y divide-gray-100 overflow-hidden bg-white shadow-xs ring-1 ring-gray-900/5 sm:rounded-xl">
                        <li className="relative flex justify-between gap-x-6 p-4 hover:bg-gray-50  items-center">
                            <div className="flex min-w-0 gap-x-4 items-center">
                                <BookmarkIcon className="text-indigo-600 size-12" />
                                <div className="min-w-0 flex-auto">
                                    <p className="text-sm/6 font-semibold text-gray-900 mb-0">
                                        <span className="absolute inset-x-0 -top-px bottom-0" />
                                        Dossier Contrat de mariage
                                    </p>
                                    <span className="inline-flex items-center rounded-md bg-indigo-50 px-2 py-1 text-xs font-medium text-indigo-600 ring-1 ring-indigo-500/10 ring-inset">
                                    Montant : 350€
                                </span>
                                </div>
                            </div>
                            <div className="flex shrink-0 items-center gap-x-4">
                                
                                {affaire.statut_paiement === "non" ? (
                                    <span className="inline-flex items-center rounded-md bg-red-50 px-2 py-1 text-xs font-medium text-red-600 ring-1 ring-red-500/10 ring-inset">
                                    Non payé
                                </span>
                                    ) : (
                                    <span className="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-600 ring-1 ring-green-500/10 ring-inset">
                                    Payé
                                </span>
                                    )}
                            </div>
                        </li>
                    </ul>
                </>}
                {type === "pacs" && <>
                    <h5 className="flex-auto truncate text-sm font-semibold leading-6 text-gray-700">Cette démarche est facturée à l'utilisateur</h5>
                    <p className="text-sm">Clotere vous reverse l'argent dès que le paiement a été fait.</p>
                    <ul className="mt-2 divide-y divide-gray-100 overflow-hidden bg-white shadow-xs ring-1 ring-gray-900/5 sm:rounded-xl">
                        <li className="relative flex justify-between gap-x-6 p-4 hover:bg-gray-50  items-center">
                            <div className="flex min-w-0 gap-x-4 items-center">
                                <BookmarkIcon className="text-indigo-600 size-12" />
                                <div className="min-w-0 flex-auto">
                                    <p className="text-sm/6 font-semibold text-gray-900 mb-0">
                                        <span className="absolute inset-x-0 -top-px bottom-0" />
                                        Dossier Convention de Pacs
                                    </p>
                                    <span className="inline-flex items-center rounded-md bg-indigo-50 px-2 py-1 text-xs font-medium text-indigo-600 ring-1 ring-indigo-500/10 ring-inset">
                                    Montant : 115€
                                </span>
                                </div>
                            </div>
                            <div className="flex shrink-0 items-center gap-x-4">
                                
                                {affaire.statut_paiement === "non" ? (
                                    <span className="inline-flex items-center rounded-md bg-red-50 px-2 py-1 text-xs font-medium text-red-600 ring-1 ring-red-500/10 ring-inset">
                                    Non payé
                                </span>
                                    ) : (
                                    <span className="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-600 ring-1 ring-green-500/10 ring-inset">
                                    Payé
                                </span>
                                    )}
                            </div>
                        </li>
                    </ul>
                </>}
                {type === "pma" && <>
                    <h5 className="flex-auto truncate text-sm font-semibold leading-6 text-gray-700">Cette démarche est facturée à l'utilisateur</h5>
                    <p className="text-sm">Clotere vous reverse l'argent dès que le paiement a été fait.</p>
                    <ul className="mt-2 divide-y divide-gray-100 overflow-hidden bg-white shadow-xs ring-1 ring-gray-900/5 sm:rounded-xl">
                        <li className="relative flex justify-between gap-x-6 p-4 hover:bg-gray-50  items-center">
                            <div className="flex min-w-0 gap-x-4 items-center">
                                <BookmarkIcon className="text-indigo-600 size-12" />
                                <div className="min-w-0 flex-auto">
                                    <p className="text-sm/6 font-semibold text-gray-900 mb-0">
                                        <span className="absolute inset-x-0 -top-px bottom-0" />
                                        Dossier PMA
                                        
                                    </p>
                                    <span className="inline-flex items-center rounded-md bg-indigo-50 px-2 py-1 text-xs font-medium text-indigo-600 ring-1 ring-indigo-500/10 ring-inset">
                                    Montant : 150€
                                </span>
                                </div>
                            </div>
                            <div className="flex shrink-0 items-center gap-x-4">
                                {affaire.statut_paiement === "non" ? (
                                    <span className="inline-flex items-center rounded-md bg-red-50 px-2 py-1 text-xs font-medium text-red-600 ring-1 ring-red-500/10 ring-inset">
                                    Non payé
                                </span>
                                    ) : (
                                    <span className="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-600 ring-1 ring-green-500/10 ring-inset">
                                    Payé
                                </span>
                                    )}
                                
                            </div>
                        </li>
                    </ul>
                </>}
                */}


            {/** AFFICHAGE DES FACTURE DU NOTAIRE */}
            <div className="flex items-center justify-around">
                <h5 className="flex-auto truncate text-sm font-semibold leading-6 text-gray-700">Honoraire notaire</h5>
                {honoraire && <>
                    <button
                        onClick={() => openDialogAjoutHonoraire(affaire.id)}
                        type="button"
                        className="inline-flex items-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                    >
                        <PlusIcon aria-hidden="true" className="mr-1.5 -ml-0.5 size-5" />
                        Demander un paiement
                    </button>
                </>}
            </div>


            <HonoraireList honoraires={honoraire} onDeleteSuccess={getHonoraireAffaire} />


            {/** MODAL UPLOAD FACTURE */}
            <Dialog open={isOpenUpload} onClose={closeDialogUpload} className="relative z-10">
                <DialogBackdrop
                    transition
                    className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity duration-500 ease-in-out data-[closed]:opacity-0"
                />
                <div className="fixed inset-0 overflow-hidden">
                    <div className="absolute inset-0 overflow-hidden">
                        <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
                            <DialogPanel
                                transition
                                className="pointer-events-auto w-screen max-w-md transform transition duration-500 ease-in-out data-[closed]:translate-x-full sm:duration-700"
                            >
                                <div className="flex h-full flex-col overflow-y-scroll bg-white py-6 shadow-xl">
                                    <div className="px-4 sm:px-6">
                                        <div className="flex items-start justify-between">
                                            <DialogTitle className="text-base font-semibold text-gray-900">Ajouter une demande d'honoraire</DialogTitle>
                                            <div className="ml-3 flex h-7 items-center">
                                                <button
                                                    type="button"
                                                    onClick={closeDialogUpload}
                                                    className="relative rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                                                >
                                                    <span className="absolute -inset-2.5" />
                                                    <span className="sr-only">Fermer</span>
                                                    <XMarkIcon aria-hidden="true" className="size-6" />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="relative mt-6 flex-1 px-4 sm:px-6">
                                        <form onSubmit={sendDemandeHonoraire}>
                                            <div className="rounded-md bg-slate-50 p-4 mb-3">
                                                <div className="flex">
                                                    <div className="ml-3 flex-1 md:flex md:justify-between">
                                                        <p className="text-sm text-slate-700">Votre client va recevoir une demande de paiement depuis son espace sécurisé, il pourra visualiser la demande et voir le RIB sur lequel faire le virement. Cela evite les fraudes au RIB par mail. </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="mb-3">
                                                <label className="mt-2 inline-flex gap-2 items-center font-bold">
                                                    Quel type de demande faites vous ?
                                                </label>
                                                <div className="mt-2 grid grid-cols-1">
                                                    <select
                                                        className="col-start-1 row-start-1 w-full appearance-none rounded-md bg-white py-1.5 pl-3 pr-8 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                                                        onChange={onChangeHonoraireDemande}
                                                        value={honoraireDemande}
                                                        name="honotairedemandeType"
                                                        required
                                                    >
                                                        <option value="" disabled>
                                                            Sélectionnez un type d'honoraire
                                                        </option>
                                                        <option value="Provision sur frais">Provision sur frais</option>
                                                        <option value="Honoraire">Honoraire</option>
                                                    </select>
                                                    <ChevronDownIcon
                                                        aria-hidden="true"
                                                        className="pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end text-gray-500 sm:size-4"
                                                    />
                                                </div>
                                            </div>

                                            <div className="mb-3">
                                                <label className="mt-2 inline-flex gap-2 items-center font-bold">
                                                    Quel est le montant de cette facture ?
                                                </label>
                                                <input required name="montant" type="text" className="input-clotere" value={montant} onChange={(e) => setMontant(e.target.value)} />

                                            </div>

                                            <div className="mb-3">
                                                <label className="mt-2 inline-flex gap-2 items-center font-bold">
                                                    Ajoutez la facture
                                                </label>
                                                {file && <div className="flex gap-2 items-center text-green-600"> <CheckCircleIcon className="size-6" /><p className="mb-0"> Document ajouté</p> </div>}
                                                {!file &&
                                                    <>
                                                        {loader ? <Loader /> : <input required onChange={onUploadFactureHonoraire} type="file" accept="application/pdf,.pdf" className="input-file" />}
                                                    </>
                                                }
                                            </div>



                                            <div className="pb-3 mt-4">
                                                <Field>
                                                    <label className="inline-flex gap-2 items-center font-bold mb-2">Accompagnez votre demande d'un message</label>
                                                    <Textarea rows="4" onChange={(e) => setMessage(e.target.value)} name="message" placeholder="Personnalisez le message de demande de document que recevra votre client." />
                                                </Field>
                                            </div>

                                            <button
                                                type="submit"
                                                disabled={!file} // 🔒 bouton désactivé si envoi en cours ou pas de fichier
                                                className="btn-primary flex items-center justify-center"
                                            >Demander le paiement
                                            </button>
                                        </form>
                                    </div>
                                </div>
                            </DialogPanel>
                        </div>
                    </div>
                </div>

            </Dialog>

        </div>

    );
};

export default Honoraires;